import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiUser, FiSearch, FiShoppingBag, FiBookOpen, FiTruck, FiGrid, FiShield, FiCreditCard } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { setIsMenuOpen(false); }, [location]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/marketplace?search=${encodeURIComponent(searchQuery)}`);
      setIsMenuOpen(false);
    }
  };

  const handleProtectedLink = (path) => {
    // ALLOWS access to Dashboard and Profile immediately
    const allowed = ['/dashboard', '/profile', '/education-hub'];
    
    // FIXED: Changed user?.kycVerified to user?.kyc_verified to match your database/Dashboard logic
    const isVerified = user?.kyc_verified === 1 || user?.kyc_verified === true;

    if (!isVerified && !allowed.includes(path)) {
      navigate('/kyc-verification');
    } else {
      navigate(path);
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-md font-sans">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-10 h-10 bg-emerald-600 rounded-xl flex items-center justify-center text-white text-2xl font-bold">🌾</div>
          <h1 className="text-2xl font-black tracking-tighter text-slate-900 uppercase">DAN</h1>
        </Link>
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-lg bg-slate-100"><FiMenu size={24} /></button>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white flex flex-col p-6 pt-20 animate-in slide-in-from-right duration-300">
          <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 p-3 bg-slate-100 rounded-full"><FiX size={28} /></button>
          
          <div className="flex flex-col h-full overflow-y-auto">
            {/* SEARCH */}
            <form onSubmit={handleSearch} className="relative mb-8">
              <input type="text" placeholder="SEARCH..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full p-4 pl-12 bg-slate-100 rounded-2xl font-black uppercase text-sm outline-none border-2 border-transparent focus:border-emerald-500" />
              <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
            </form>

            {isAuthenticated ? (
              <>
                {/* BEAUTIFUL COLORFUL LINKS */}
                <div className="space-y-6 mb-8 border-b pb-8 border-slate-100">
                  <button onClick={() => handleProtectedLink('/dashboard')} className="flex items-center gap-3 w-full text-left font-black text-4xl uppercase text-indigo-600 tracking-tighter"><FiGrid size={28}/> DASHBOARD</button>
                  <button onClick={() => handleProtectedLink('/marketplace')} className="flex items-center gap-3 w-full text-left font-black text-4xl uppercase text-fuchsia-600 tracking-tighter"><FiShoppingBag size={28}/> MARKETPLACE</button>
                  <button onClick={() => handleProtectedLink('/orders')} className="flex items-center gap-3 w-full text-left font-black text-4xl uppercase text-blue-500 tracking-tighter"><FiTruck size={28}/> ORDERS</button>
                  <button onClick={() => handleProtectedLink('/education-hub')} className="flex items-center gap-3 w-full text-left font-black text-4xl uppercase text-amber-500 tracking-tighter"><FiBookOpen size={28}/> EDUCATION</button>
                  <button onClick={() => handleProtectedLink('/profile')} className="flex items-center gap-3 w-full text-left font-black text-4xl uppercase text-slate-700 tracking-tighter"><FiUser size={28}/> PROFILE</button>
                </div>

                {/* HUGE STATUS LINKS */}
                <div className="space-y-6 mb-12">
                  <button onClick={() => handleProtectedLink('/settings')} className="flex items-center justify-between w-full font-black text-5xl uppercase text-orange-500 tracking-tighter leading-none">KYC VERIFY <FiShield /></button>
                  <button onClick={() => handleProtectedLink('/settings')} className="flex items-center justify-between w-full font-black text-5xl uppercase text-emerald-600 tracking-tighter leading-none">PAYMENTS <FiCreditCard /></button>
                </div>

                <div className="mt-auto pt-6 text-center">
                  <p className="text-[10px] font-black text-slate-400 tracking-widest uppercase mb-1">Account Number</p>
                  {/* UPDATED: Using account_number to match your stored data +2348108701226 */}
                  <p className="font-bold text-slate-600 mb-6">{user?.account_number || user?.phone || '+2348108701226'}</p>
                  <button onClick={logout} className="w-full py-5 bg-red-50 text-red-600 rounded-2xl font-black uppercase text-xs">LOGOUT</button>
                </div>
              </>
            ) : (
              <div className="space-y-4">
                <Link to="/login" className="block font-black text-5xl uppercase text-slate-900 tracking-tighter">LOGIN</Link>
                <Link to="/signup" className="block font-black text-5xl uppercase text-emerald-600 tracking-tighter">SIGN UP</Link>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};
export default Navbar;